module.exports = __webpack_public_path__ + "img/france.4b92498f.jpg";